import {useNavigate, useParams} from "react-router-dom";
import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import Breadcrumbs from '@mui/joy/Breadcrumbs';
import Link from '@mui/joy/Link';
import {BotInventory} from './botTabs/BotInventory';
import {BotGeneralInfo} from './botTabs/BotGeneralInfo';
import {BotStats} from './botTabs/BotStats';
import {BotOrders} from './botTabs/BotOrders';
import {NavigationTabs} from '../../components/tab/NavigationTabs';

export function Bot() {
    const {id} = useParams();
    const navigate = useNavigate();

    return (
        <Box sx={{display: 'flex', minHeight: '100dvh'}}>
            <Box
                component="main"
                className="MainContent"
                sx={{
                    px: {xs: 2, md: 6},
                    pt: {
                        xs: 'calc(12px + var(--Header-height))',
                        sm: 'calc(12px + var(--Header-height))',
                        md: 3,
                    },
                    pb: {xs: 2, sm: 2, md: 3},
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    minWidth: 0,
                    gap: 1,
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        mb: 1,
                        gap: 1,
                        flexDirection: {xs: 'column', sm: 'row'},
                        alignItems: {xs: 'start', sm: 'center'},
                        flexWrap: 'wrap',
                        justifyContent: 'space-between',
                    }}
                >
                    <Breadcrumbs
                        size="sm"
                        aria-label="breadcrumbs"
                        separator={<ChevronRightRoundedIcon/>}
                        sx={{pl: 0}}
                    >
                        <HomeRoundedIcon/>
                        <Link
                            underline="hover"
                            color="neutral"
                            sx={{fontSize: 12, fontWeight: 500}}
                            onClick={() => navigate('/app/bots')}
                        >
                            Боты
                        </Link>
                        <Typography color="primary" sx={{fontWeight: 500, fontSize: 12}}>
                            {id}
                        </Typography>
                    </Breadcrumbs>
                </Box>
                <Typography level="h2" component="h1">
                    Бот #{id}
                </Typography>
                <NavigationTabs tabs={[
                    {
                        tabSlug: 'general',
                        tabTitle: 'Общая информация',
                        tabContent: <BotGeneralInfo/>
                    },
                    {
                        tabSlug: 'stats',
                        tabTitle: 'Статистика',
                        tabContent: <BotStats/>
                    },
                    {
                        tabSlug: 'inventory',
                        tabTitle: 'Инвентарь',
                        tabContent: <BotInventory/>
                    },
                    {
                        tabSlug: 'orders',
                        tabTitle: 'Заказы',
                        tabContent: <BotOrders/>
                    },
                ]} />
            </Box>
        </Box>
    );
}
